export default __webpack_public_path__ + "static/media/giftSuccessfull.36e71fa9.webp";